import { EntriesData, TableBodyProps } from 'features/LotteryEntries/types';

import { COLUMN_MIN_WIDTH } from './constants';
import { DataRow } from './EntriesTable.styles';
import { FC } from 'react';
import { Table } from 'features/common/components/Table';
import { getStatus } from '../RunLotteryModal/utils';
import * as Styles from './TableBody.styles';
import { useResendEmail } from '../../hooks/useEventLotteryEntries';

export const TableBody: FC<TableBodyProps> = ({ entriesQueryObject, columnsN = 0 }) => {
	const { data: entries } = entriesQueryObject;
	const { resendEmail } = useResendEmail();

	const renderCell = (value: string | number, minWidth: number, maxWidth?: number) => (
		<Table.Cell minWidth={minWidth} maxWidth={maxWidth}>
			{value}
		</Table.Cell>
	);

	const renderButtonCell = (entry: EntriesData, minWidth: number, maxWidth?: number) => (
		<Table.Cell minWidth={minWidth} maxWidth={maxWidth}>
			{['winner', 'claimed'].includes(entry.Status) && (
				<Styles.ResendEmailButton onClick={() => resendEmail(entry.ID)} />
			)}
		</Table.Cell>
	);

	if (!entries || entries?.pages?.length === 0) {
		return null;
	}

	return (
		<tbody>
			{entries.pages.map((page: EntriesData[]) =>
				page.map((entry) => (
					<DataRow gridColumns={`repeat(${columnsN}, 1fr)`} key={[entry.ID].join('_')} textAlign="center">
						{renderCell(entry.Email || '', COLUMN_MIN_WIDTH[2])}
						{renderCell(entry.FirstName || '', COLUMN_MIN_WIDTH[0])}
						{renderCell(entry.LastName || '', COLUMN_MIN_WIDTH[1])}
						{renderCell(entry.ZipCode || '', COLUMN_MIN_WIDTH[3])}
						{renderCell(entry.NumberOfTickets || 0, COLUMN_MIN_WIDTH[4])}
						{renderCell(getStatus(entry.Status), COLUMN_MIN_WIDTH[5])}
						{renderCell(entry.WheelchairAccess ? 'Yes' : 'No', COLUMN_MIN_WIDTH[7])}
						{renderCell(entry.OptOutMailing ? 'Yes' : 'No', COLUMN_MIN_WIDTH[8])}
						{renderCell(entry.Gender || '', COLUMN_MIN_WIDTH[9])}
						{renderCell(entry.Age || '', COLUMN_MIN_WIDTH[9])}
						{renderCell(entry.Ethnicity || '', COLUMN_MIN_WIDTH[9])}
						{renderCell(entry.HouseholdIncome || '', COLUMN_MIN_WIDTH[9])}
						{renderCell(entry.IdentifyGroups || '', COLUMN_MIN_WIDTH[9])}
						{renderButtonCell(entry, COLUMN_MIN_WIDTH[9])}
					</DataRow>
				))
			)}
		</tbody>
	);
};
